export default {
  TOGGLE_DISPLAY: ({ commit, state }) => {
    if (state.displayCards) {
      commit('RESET_STORE');
      // Toggle list
      commit('SET_DISPLAY_LIST', true);
      commit('SET_DISPLAY_CARDS', false);
      // Set default values for sorting table
      commit('SET_SORT_KEY', 'updated');
      commit('SET_SORT_ORDER', 'DESC');
      // Disable confluence search
      commit('SET_SEARCH_CONFLUENCE', false);
    } else {
      commit('RESET_STORE');
      // Toggle card
      commit('SET_DISPLAY_LIST', false);
      commit('SET_DISPLAY_CARDS', true);
      // Disable sorting
      commit('SET_SORT_KEY', null);
      commit('SET_SORT_ORDER', null);
    }
  },

  HEADER_CLICK: ({ commit, state }, { key }) => {
    if (key === state.sortKey) {
      commit('SET_SORT_ORDER', (state.sortOrder === 'DESC') ? 'ASC' : 'DESC');
    } else {
      commit('SET_SORT_KEY', key);
      commit('SET_SORT_ORDER', 'DESC');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/actions.js